// extracted by mini-css-extract-plugin
export var fileUpload = "_fx-1";
export var modalButton = "_fx-0";